import React, { useState } from "react";
import BackButton from "src/legacy/components/BackButton";
import styles from "./styles.module.scss";
import { localizedStrings } from "src/localization/index.jsx";
import { Image } from "react-bootstrap";
import SwitchButton from 'src/components/switchButton';
import MsDynamicsIcon from "src/legacy/images/msDynamics.png";
import _ from 'lodash'; 

export const MsDynamicsSideBar = (props) => {


const localizedIntegrations = localizedStrings.components.integrations;
const localizedMsDynamics = localizedStrings.components.integrations.ms_dynamics;
const localizedCommons = localizedStrings.commons;
const localizedIntgerationActions = localizedStrings.components.integrations.actions;
const integration = localizedStrings.constants.integrationsOnboarding.integrations.ms_dynamics;
const support_articles =  localizedStrings.constants.integrationsOnboarding.integrations.ms_dynamics.support_articles;

const [showSeeMore, setShowSeeMore] = useState(true);
const [showCtaButton, setshowCtaButton] = useState(true);

const handleChange = () => {
    props.showIntergrationOnboarding();
}

const handleSeeMore = () => {
    const container = document.getElementById('articles');
    const element = container.querySelector('ol li:last-child');
    if (container) {
      const scrollHeight = element.offsetTop;
      container.scrollTo({ top: scrollHeight, behavior: "smooth" });
    }
    setShowSeeMore(false);
  }

  const handleShowCta = () => {
    props.handleOnboardingComplete();
    setshowCtaButton(false); 
};

return (
    <div className={styles.sideBar}>
    <BackButton
        className={styles.back}
        title={localizedCommons.actions.back}
        onClick={() => {
        props.navigate("/settings/integrations");
        }}
    />
  <div className={styles.headerContainer}> 
    <div className={styles.heading}>
        <Image src={MsDynamicsIcon} />
        <h2 className={styles.name}>{localizedMsDynamics.title}</h2>
        <p className={styles.description}>{localizedMsDynamics.sub_text}</p>
    </div>

    <div className={styles.actions}>
        {showCtaButton && ((_.get(props, "integration") && !props.isAuthenticated) || (_.get(props, "integration") && props.isTokenExpired)) && props.canEdit() && (
        <button 
            onClick={handleShowCta}
            disabled={props.authenticating} 
            className={styles.button}>
            {props.authenticating ? localizedIntgerationActions.authenticating + "..." : localizedIntgerationActions.re_authenticate}
        </button>
    )
}
       {(showCtaButton && ((!_.get(props, "integration") && !props.isAuthenticated && props.canEdit()))) && (
        <button 
            onClick={handleShowCta}
            disabled={props.authenticating} className={styles.button}>
            {!props.deactivating && localizedIntgerationActions.connect_now}
        </button>
       )
       }
        
        {(_.get(props, "integration")) &&
            props.isAuthenticated &&
            !props.isTokenExpired && props.canEdit() && (
            <button
                className={styles.button}
                disabled={props.deactivating}
                onClick={() => props._handleDeactivateClicked()}
            >
            {props.deactivating &&
                `${localizedIntgerationActions.deactivating}...`}
            {!props.deactivating && localizedIntgerationActions.deactivate}
            </button>
        )}
    </div>
    </div>
    <div className={styles.footerContainer}>


    <div className={styles.footer}>
    <div
        className={styles.articles}
        id="articles"
    >
        <span>{support_articles.title}</span>
        <ol>
        {support_articles.content.map((article, index) => {
            return (
            <li key={index} className={styles.article}>
                <a href={article.url} target="_blank">{article.title}</a>
            </li>
            )
        })}
        </ol>
    </div>

    {_.size(support_articles.content) > 4 && showSeeMore && (
        <div className={styles.seeMore} onClick={handleSeeMore}>{localizedCommons.actions.see_more}</div>
    )}
    {(_.get(props, "integration"))  && (
        <div className={styles.moreActions}>
        <span>{localizedIntegrations.learn_more}</span>
            <SwitchButton
            id={`integrationOnboarding`}
            className={styles.switch}
            label={localizedIntgerationActions.show_onboarding_label}
            checked={props.isShowIntergrationOnboarding}
            handleCheck={() =>handleChange()} />
        </div>
    )} 
    </div>
    </div>
    </div>
);
};